import { DevisStatut } from './devis';

export enum FebStatut {
  CREEE                  = 'CREEE',
  EN_ATTENTE             = 'EN_ATTENTE',
  VALIDEE               = 'VALIDEE',
  ARCHIVEE  = 'ARCHIVEE',
}

export interface IFicheExpressionBesoinResponse {
  febId: string;

  febPilotLotId: string | null;
  febPilotLotNom: string | null;

  febDemandeurId: string;
  febDemandeurNom: string;
  febNumber: string | null;

  febEntiteSncfId: string | null;
  febEntiteSncfNom: string | null;

  febDivisionDemandeurId: string | null;
  febDivisionDemandeurNom: string | null;

  febProjectId: string | null;
  febProjectNom: string | null;

  febDemandId: string | null;
  febDemandReference: string | null;

  devisId?: string | null;
  devisStatut?: DevisStatut | null;
  devisDemandId?: string | null;

  febLabel: string;

  febPcSncf: boolean | null;
  febDateDemande: string | null;
  febDateDemarrage: string | null;
  febDateFinPrevisionnelle: string | null;

  febLocalisationId: string | null;
  febLocalisationLabel: string | null;
  febDuree: number | null;

  febUoActivitePressentiId: string | null;
  febUoActivitePressentiLabel: string | null;
  febUoNomenclatureLabel: string | null;

  febNomenclature: string | null;
  febPresenceSiteSncf: string | null;
  febProvisionDeplacementAstreinte: number | null;

  febContexteObjectifProjet: string | null;
  febDescriptionBesoin: string | null;

  febActivites: IFebActivite[] | null;

  febNbAnneesExperiences: string | null;
  febCompetencesFonctionnelles: string | null;
  febCompetencesTechniques: string | null;
  febEnvironnementTechnique: string | null;
  febSavoirEtreQualites: string | null;

  febCreatedById: string | null;
  febCreatedByNom: string | null;
  febStatut: FebStatut | null;
  createdAt: string;
  updatedAt: string;
}

export interface IFebActivite {
  label: string;
  pourcentage: number;
}

export interface IFicheExpressionBesoinRequest {
  febPilotLotId?: string;
  febDemandeurId: string;
  febEntiteSncfId?: string;
  febDivisionDemandeurId?: string;
  febProjectId?: string;
  febLabel: string;
  febPcSncf?: boolean;
  febDateDemande?: string;
  febDateDemarrage?: string;
  febDateFinPrevisionnelle?: string;
  febLocalisationId?: string;
  febDuree?: number;
  febUoActivitePressentiId?: string;
  febNomenclature?: string;
  febPresenceSiteSncf?: string;
  febProvisionDeplacementAstreinte?: number;  
  febContexteObjectifProjet?: string;
  febDescriptionBesoin?: string;
  febActivites: IFebActivite[];
  febNbAnneesExperiences?: string;
  febCompetencesFonctionnelles?: string;
  febCompetencesTechniques?: string;
  febEnvironnementTechnique?: string;
  febSavoirEtreQualites?: string;
  febCreatedById?: string;
}


export interface IApplication{
  name: string;
}
 
